import { Component, Input, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CustomButton } from '../shared/custom-button';
import { CustomDialogWindow } from '../shared/custom-dialog-window';

@Component({
  selector: 'rl-custom-dialog-window',
  templateUrl: './custom-dialog-window.component.html',
  styleUrls: ['./custom-dialog-window.component.scss']
})
export class CustomDialogWindowComponent implements OnInit {

  @Input() dialog : CustomDialogWindow;

  rightBtns : CustomButton[];
  leftBtns : CustomButton[];
  
  constructor(private modal : BsModalService) { }

  ngOnInit(): void {
    this.rightBtns = this.dialog.buttons?.filter(b => b.place == 'right');
    this.leftBtns = this.dialog.buttons?.filter(b => b.place == 'left');
  }

  close = () => this.closeModals();

  clickBtn(b : CustomButton){
    if(b.action) b.action();
    this.close();
  }

  closeModals(){
  	let modals = this.modal.getModalsCount()
    while(modals > 0){
      this.modal.hide(modals--);
    }
    this.modal.hide();
  }
}
